import actionCreatorFactory from 'typescript-fsa';
import { CCFEntryPointsResponse } from '@shared/types/mylounge/ccfEntries';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchCCFEntries = actionCreator.async<null, CCFEntryPointsResponse, string>(
    'FETCH_CCF_ENTRIES',
);
